import { Component, OnInit, Input, ViewEncapsulation, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { ActivatedRoute } from '@angular/router';
import { isPlatformServer } from '@angular/common';
//import { ViewportScroller } from '@angular/common';
@Component({
  selector: 'app-rich-content',
  templateUrl: './rich-content.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class RichContentComponent implements OnInit , AfterViewInit {
  @Input() rendering: ComponentRendering;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  twoTables: boolean = false
  _isPlatformServer: boolean = false;

  constructor(jssStylingService: JssStylingService,@Inject(PLATFORM_ID) public readonly platformId: string,private route: ActivatedRoute) {
    this.jssStylingService = jssStylingService;
    platformId
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('RichContent component initialized with component data', this.rendering);
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);

    this.twoTables = (this.rendering.fields?.TwoTables as any)?.value ? true : false;
  }

  ngAfterViewInit(): void {
    if (!this._isPlatformServer){
      this.route.queryParamMap.subscribe(params => {
        const scrollTo = params.get('scrollTo');
        if (scrollTo) {
          setTimeout(() => {
            document.getElementById(scrollTo)?.scrollIntoView({ block: 'center' });
          }, 0);
        }
      });
  
      const links = document.querySelectorAll('a[id^="scrollLink"]');
      
      if (links && links.length > 0) {
        // For each link with id starting with 'scrollLink', add a click event listener
        links.forEach(link => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            const href = (link as HTMLAnchorElement).getAttribute('href'); 
            if (href && href.startsWith('#')){
              const targetId = href.substring(1); // remove #
              document.getElementById(targetId)?.scrollIntoView({block:'center'});
            }  
          });
        });
        
      }
    }
  }
}
